<template>
  <div v-if="events">
    <b-button variant="info" size="lg" @click="showEventModal">Events</b-button>
    <b-modal ref="eventModal" title="Events" :hide-footer="true">
      <h3>{{properties.title}}</h3>
      <div v-if="events.length > 0">
        <div role="tablist">
          <div v-for="(event, index) in events" :key="index">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" variant="info">{{eventName(event)}} - {{index + 1}}</b-button>
              </b-card-header>
              <b-card-body>
                <div class="form-group">
                  <label for="type">type</label>
                  <v-select
                    id="type"
                    v-model="event.type"
                    :options="properties['allowed_values']"
                    size="sm"
                    class="mt-3"
                  ></v-select>
                </div>

                <div v-if="event.type !== 'reset_app'">
                  <div v-if="event.type !== 'flip'">
                    <hr />
                    <div v-if="event.type" class="form-group">
                      <label>Target Element</label>
                      <v-select v-if="(event.type === 'show_modal' || event.type === 'hide_modal') && modalMap.length > 0"
                                :options="modalMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'play_video' || event.type === 'pause_video') && videoMap.length > 0"
                                :options="videoMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'play_audio' || event.type === 'pause_audio') && audioMap.length > 0"
                                :options="audioMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'timer_start' || event.type === 'timer_stop' || event.type === 'timer_reset') && timerMap.length > 0"
                                :options="timerMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="event.type === 'reset_tree_to_default' && componentMap.length > 0"
                                :options="componentMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="event.type === 'triggered' && modalMap.length > 0"
                                :options="modalMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="nameMap.length > 0"
                                :options="nameMap"
                                :reduce="option => option.value"
                                v-model="event.target_uuid"
                                :key="`select-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                    </div>
                    <!-- show with survey -->
                    <div v-if="event.type === 'show_with_survey'">
                      <label for="target_survey">Target Survey</label>
                      <v-select v-if="surveyMap.length > 0"
                                id="target_survey"
                                v-model="event.survey"
                                :options="surveyMap"
                                size="sm"
                                class="mt-3"
                                :reduce="option => option.value"
                      ></v-select>
                    </div>
                    <!-- show_on_survey_close -->
                    <div v-if="event.type === 'show_survey'">
                      <label for="target_survey">Target to Show on Survey Close</label>
                      <b-form-select
                        id="show_on_survey_close"
                        v-model="event.show_on_survey_close"
                        :options="getOptions(event)"
                        size="sm"
                        class="mt-3"
                        :required="true"
                        @change="updateEvents"
                      ></b-form-select>
                    </div>
                    <!-- getFormData: form container-->
                    <div v-if="event.type === 'get_form_data'">
                      <label>Target Form Container</label>
                      <v-select v-if="(event.type === 'show_modal' || event.type === 'hide_modal') && modalMap.length > 0"
                                :options="modalMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'play_video' || event.type === 'pause_video') && videoMap.length > 0"
                                :options="videoMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'play_audio' || event.type === 'pause_audio') && audioMap.length > 0"
                                :options="audioMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'timer_start' || event.type === 'timer_stop' || event.type === 'timer_reset') && timerMap.length > 0"
                                :options="timerMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="event.type === 'reset_tree_to_default' && componentMap.length > 0"
                                :options="componentMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="event.type === 'triggered' && modalMap.length > 0"
                                :options="modalMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="nameMap.length > 0"
                                :options="nameMap"
                                :reduce="option => option.value"
                                v-model="event.form_container"
                                :key="`selectForm-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                    </div>
                    <!-- getFormData: modal_target -->
                    <div v-if="event.type === 'get_form_data'">
                      <label>Target Modal (Upon Success)</label>
                      <v-select v-if="(event.type === 'show_modal' || event.type === 'hide_modal') && modalMap.length > 0"
                                :options="modalMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'play_video' || event.type === 'pause_video') && videoMap.length > 0"
                                :options="videoMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'play_audio' || event.type === 'pause_audio') && audioMap.length > 0"
                                :options="audioMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="(event.type === 'timer_start' || event.type === 'timer_stop' || event.type === 'timer_reset') && timerMap.length > 0"
                                :options="timerMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="event.type === 'reset_tree_to_default' && componentMap.length > 0"
                                :options="componentMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="event.type === 'triggered' && modalMap.length > 0"
                                :options="modalMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                      <v-select v-else-if="nameMap.length > 0"
                                :options="nameMap"
                                :reduce="option => option.value"
                                v-model="event.modal_target"
                                :key="`selectSuccessModal-${event.target_uuid}`"
                                size="sm"
                                class="mt-3" />
                    </div>
                    <div v-if="event.type === 'change' || event.type === 'triggered'">
                      <div v-if="event.target_uuid" class="form-group">
                        <label for="property_to_change">Property To Change</label>
                        <v-select
                          id="property_to_change"
                          v-model="event.property_to_change"
                          :options="targetAllowedProperties(event.target_uuid)"
                          size="sm"
                          class="mt-3"
                          :reduce="event => event.value"
                        ></v-select>
                      </div>
                      <div v-if="event.property_to_change" class="form-group">
                        <label for="new_value">Change value to</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="event.new_value"
                          :placeholder="event.new_value"
                          id="new_value"
                        />
                      </div>
                    </div>
                    <div v-else-if="event.type === 'add_class' || event.type === 'remove_class'">
                      <label for="add_or_remove_class">Add or remove class</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="event.new_value"
                        :placeholder="event.new_value"
                        id="add_or_remove_class"
                      />
                    </div>
                  </div>
                  <div v-else-if="event.type === 'flip'">
                    <div class="form-group">
                      <label for="target_flip_uuid">Target Element</label>
                      <v-select v-if="nameMap.length > 0"
                                id="target_flip_uuid"
                                v-model="event.target_uuid"
                                :options="nameMap"
                                size="sm"
                                class="mt-3"
                                :reduce="event => event.value"
                      ></v-select>
                    </div>
                  </div>
                </div>
                <br/>
                <b-button variant="outline-success" @click="updateEvents"><font-awesome-icon icon="save" /> - Save Event</b-button>
                <br/>
                <br/>
                <b-button variant="danger" @click="removeEvent(event)"><font-awesome-icon icon="trash" /> - Remove Event</b-button>
              </b-card-body>
            </b-card>
            <h4></h4>
            <hr/>
          </div>
        </div>
      </div>
      <div>
        <b-button @click="newEvent"><font-awesome-icon icon="plus" /> New Event</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import PropertyOptions from '../../mixins/property-options';
import EditorEvents from '../../mixins/editor-events';
import { usePageEditorStore } from '@/stores/PageEditorStore';

export default {
  name: 'PageEditorPropertiesEvents',
  mixins: [EditorEvents, PropertyOptions],
  props: {
    events: Array,
    properties: Object,
    eventTemplate: Object,
    components: Array,
    dataObject: Object,
    reload: Boolean,
  },
  setup() {
    const pageEditorStore = usePageEditorStore();
    return {
      pageEditorStore,
    };
  },
  data() {
    return {
      modalMap: [],
      videoMap: [],
      audioMap: [],
      timerMap: [],
      componentMap: [],
      nameMap: [],
      surveyMap: [],
      selfMap: [
        {
          text: 'self',
          value: this.dataObject.uuid,
          label: 'self',
          code: this.dataObject.uuid,
        },
      ],
    };
  },
  mounted() {
    this.generateMaps();
  },
  watch: {
    reload() {
      this.generateMaps();
    },
  },
  methods: {
    generateMaps() {
      if (Vue.prototype.$cachesBuilt === false) {
        this.buildCaches();
      }
      this.modalMap = Vue.prototype.$modalMapCache;
      this.videoMap = Vue.prototype.$videoMapCache;
      this.audioMap = Vue.prototype.$audioMapCache;
      this.timerMap = Vue.prototype.$timerMapCache;
      this.nameMap = Vue.prototype.$nameMapCache;
      this.componentMap = Vue.prototype.$componentMapCache;
      this.surveyMap = Vue.prototype.$surveyMapCache;
    },
    eventName(event) {
      let name = '';
      if (event) {
        if (event.type) {
          name = event.type;
        } else {
          name = 'Name';
        }
      }
      return name;
    },
    newEvent() {
      const event = JSON.parse(JSON.stringify(this.eventTemplate));
      event.id = uuidv4();
      if (this.dataObject) {
        event.source = this.dataObject.uuid;
      }
      this.events.push(event);
      this.updateEvents();
    },
    removeEvent(event) {
      for (let i = 0; i < this.events.length; i += 1) {
        const storedEvent = this.events[i];
        if (storedEvent.id === event.id) {
          this.events.splice(i, 1);
        }
      }
      this.updateEvents();
    },
    updateEvents() {
      this.$emit('onChange', this.events);
    },
    getOptions(event) {
      let options = [];
      if (event && event.type) {
        if (event.type === 'show_modal') {
          options = this.modalMap;
        } else if (event.type === 'hide_modal') {
          options = this.modalMap;
        } else if (event.type === 'play_video') {
          options = this.videoMap;
        } else if (event.type === 'pause_video') {
          options = this.videoMap;
        } else if (event.type === 'play_audio') {
          options = this.audioMap;
        } else if (event.type === 'pause_audio') {
          options = this.audioMap;
        } else if (event.type === 'timer_stop') {
          options = this.timerMap;
        } else if (event.type === 'timer_start') {
          options = this.timerMap;
        } else if (event.type === 'timer_reset') {
          options = this.timerMap;
        } else if (event.type === 'reset_tree_to_default') {
          options = this.componentMap;
        } else if (event.type === 'triggered') {
          options = [
            {
              text: 'self',
              value: this.dataObject.uuid,
              label: 'self',
              code: this.dataObject.uuid,
            },
          ];
        } else {
          options = this.nameMap;
        }
      }
      return _.sortBy(options, ['text']);
    },
    targetAllowedProperties(targetUuid) {
      let allowedProps = [];
      if (targetUuid) {
        const element = this.findFirstObjectInArrayByProp(Vue.prototype.$elementMap, 'uuid', targetUuid);
        if (element) {
          const optionSheet = this.loadPropertyOptions(element);
          const elementType = element.properties.element_type;
          allowedProps = optionSheet.prop[elementType].allowed_props;
        }
      }
      return allowedProps;
    },
    showEventModal() {
      this.$refs.eventModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
